import { usePromisedRequest as promiseRequest } from "../Common/request";
import { resolveWithBody } from "./Utils/utils";
import { AcademyRole } from "./academies";

export type CoachPassEntry = {
    academyName: string;
    name: string;
    role: AcademyRole | null;
    email: string | null;
    isShadow: boolean;
    hasCoach: boolean;
    isBlankPass: boolean;
    included: boolean;
};

export type CoachPassSettings = {
    passesPerBlock: number | null;
    competitorsPerBlock: number | null;
    fillWithBlank: boolean;
    blankNames: boolean;
};

export const noCoachPassLimit: CoachPassSettings = {
    passesPerBlock: null,
    competitorsPerBlock: null,
    fillWithBlank: false,
    blankNames: false,
};

/**
 * Query string ("?a=1&b=2" or "") sent with the listing, CSV and PDF requests, so all three always show the same passes.
 */
export function coachPassSettingsQuery(settings: CoachPassSettings): string {
    const params = new URLSearchParams();
    if (settings.passesPerBlock !== null && settings.competitorsPerBlock !== null) {
        params.set("passesPerBlock", String(settings.passesPerBlock));
        params.set("competitorsPerBlock", String(settings.competitorsPerBlock));
    }
    if (settings.fillWithBlank) {
        params.set("fillWithBlank", "1");
    }
    if (settings.blankNames) {
        params.set("blankNames", "1");
    }
    const query = params.toString();

    return query === "" ? "" : `?${query}`;
}

export type CoachPassListing = {
    members: CoachPassEntry[];
};

export default {
    getListing(eventId: number, settings: CoachPassSettings): Promise<CoachPassListing> {
        return promiseRequest<CoachPassListing>({
            url: `/api/admin/events/${eventId}/coach-passes${coachPassSettingsQuery(settings)}`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
};
